import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";

export default function Register() {
  const { user, register } = useAuth();
  const [form, setForm] = useState({ email: "", password: "", name: "", company_name: "", country: "IT" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  if (user) return <Navigate to="/dashboard" replace />;

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Azienda registrata");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid-bg flex items-center justify-center p-8">
      <form onSubmit={onSubmit} className="w-full max-w-md bg-white border border-border p-8 rounded-md shadow-sm animate-rise-in" data-testid="register-form">
        <div className="mb-6"><img src="/brand/sofmat-quoteos-logo.png" alt="SOFMAT QuoteOS" className="h-10 w-auto" draggable={false} data-testid="brand-logo-register" /></div>
        <div className="text-[10px] uppercase tracking-caps font-bold text-muted-foreground mb-2">Nuovo tenant</div>
        <h2 className="text-2xl font-black tracking-tight">Registra la tua officina</h2>
        <p className="text-sm text-muted-foreground mb-6">Creerai automaticamente un tenant isolato e l'utente Owner.</p>
        <div className="space-y-3">
          <div>
            <Label>Nome azienda</Label>
            <Input data-testid="reg-company" value={form.company_name} onChange={set("company_name")} required />
          </div>
          <div>
            <Label>Il tuo nome</Label>
            <Input data-testid="reg-name" value={form.name} onChange={set("name")} required />
          </div>
          <div>
            <Label>Email</Label>
            <Input data-testid="reg-email" type="email" value={form.email} onChange={set("email")} required />
          </div>
          <div>
            <Label>Password (min 8)</Label>
            <Input data-testid="reg-password" type="password" value={form.password} onChange={set("password")} required minLength={8} />
          </div>
          <Button type="submit" className="w-full" data-testid="reg-submit" disabled={loading}>
            {loading ? "Creazione..." : "Crea azienda"}
          </Button>
        </div>
        <div className="mt-4 text-xs text-muted-foreground">
          Hai già un account? <Link to="/login" data-testid="link-login" className="link-tech font-semibold hover:underline">Accedi</Link>
        </div>
      </form>
    </div>
  );
}
